// extracted by mini-css-extract-plugin
module.exports = {"statbox":"Stat-module--statbox--uyaIz","icon":"Stat-module--icon--xbN0w","number":"Stat-module--number--2wIJy","text":"Stat-module--text--11I4Q","plus":"Stat-module--plus--QM3Bi"};